var _effectorFileName = "/builds/gmini/front-ui-kit/src/icons/WarningFilled.tsx";
import { jsx as _jsx } from "react/jsx-runtime";
export const WarningFilled = ({
  color = '#EC868B',
  ...other
}) => /*#__PURE__*/_jsx("svg", {
  width: "18",
  height: "18",
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...other,
  children: /*#__PURE__*/_jsx("path", {
    d: "M7.75033 12.7497C7.75033 13.44 8.30997 13.9997 9.00033 13.9997C9.69068 13.9997 10.2503 13.44 10.2503 12.7497C10.2503 12.0593 9.69068 11.4997 9.00033 11.4997C8.30997 11.4997 7.75033 12.0593 7.75033 12.7497ZM8.10762 9.00179C8.14107 9.47014 8.53078 9.83301 9.00033 9.83301C9.46987 9.83301 9.85958 9.47014 9.89303 9.00179L10.1738 5.07092C10.2152 4.49205 9.75669 3.99967 9.17635 3.99967H8.8243C8.24396 3.99967 7.7855 4.49205 7.82684 5.07092L8.10762 9.00179ZM9.00033 17.333C4.40033 17.333 0.666992 13.5997 0.666992 8.99967C0.666992 4.39967 4.40033 0.66634 9.00033 0.66634C13.6003 0.66634 17.3337 4.39967 17.3337 8.99967C17.3337 13.5997 13.6003 17.333 9.00033 17.333Z",
    fill: color
  })
});